module.exports = __webpack_public_path__ + "static/img/psychological_training.01b4a2e0.png";